import PropTypes from 'prop-types';
import React from 'react';

import { Link } from 'react-router';
import FootballMatchListItem from './FootballMatchListItem';


import { toSlug } from 'utils';

require("./FootballMatchList.scss");

function competitionHref(competitionId, competitionName, fixturesResults) {
  return `/football/${fixturesResults}/competitions/${toSlug(competitionName)}/${competitionId}`;
}

export default function FootballMatchList({ matchList = [], showCompetitions, fixturesResults }) {

  return (
    <ul>
      {
        matchList.map(match => {
          const {
            match_reference: {
              id: matchId
            },
            competition: {
              competition_reference: {
                id: competitionId
              } = {},
              name: competitionName
            } = {},
          } = match;

          return (
            <li key={matchId}>
              {showCompetitions && <div className='competition-name'><Link to={competitionHref(competitionId, competitionName, fixturesResults)}>{competitionName}</Link></div>}
              <FootballMatchListItem match={match} />
            </li>
          );
        })
      }
    </ul>
  );
}

FootballMatchList.propTypes = {
  matchList: PropTypes.array.isRequired,
  fixturesResults: PropTypes.string,
  showCompetitions: PropTypes.bool
};




// WEBPACK FOOTER //
// ./modules/Football/components/FootballMatchList.js